import { get } from "./base";

export async function getGoldTeacherList() {
    let respObj = await get("/edu-classroom/lecturer/list");
    if (respObj != false) {
        // 处理接口数据
        let result = [];
        if (respObj.length > 0) {
            let maxInGroup = 8;
            // 每8个教师一组，计算总共有几个分组
            let groupCount = 0;
            if (respObj.length % maxInGroup == 0) {
                groupCount = respObj.length / maxInGroup;
            } else {
                groupCount = parseInt(respObj.length / maxInGroup) + 1;
            }
            for (let groupIndex = 0; groupIndex < groupCount; groupIndex++) {
                let group = [];
                for (let index = 0; index < maxInGroup; index++) {
                    let indexInTeacherList = groupIndex * maxInGroup + index;
                    if (indexInTeacherList >= respObj.length) {
                        // 下标已超出原数组长度，跳出循环
                        break;
                    }
                    const teacher = respObj[indexInTeacherList];
                    let name = teacher.name;
                    let avatar = teacher.avatar;
                    let intro = teacher.content;
                    let id = teacher.id
                    group.push({ id, name, avatar, intro })
                }
                result.push(group);
            }
        }
        return result;
    } else {
        return [];
    }
}
